var base = require('../product/base');
require('../product/calculator');
require('../product/availability');
require('../einsteinCarousel');
var focusHelper = require('base/components/focus');
var location = window.location;
var errorSintrGif = $('input[name="errorSintrGif-1"]').val();
window.fromButtonQuote = false;
var geolocationHelper = require('../geolocation/geolocationHelper');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl +=
        (newUrl.indexOf('?') !== -1 ? '&' : '?') +
        Object.keys(params)
            .map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            })
            .join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml =
                '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' +
                data.valid.message +
                '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart')
                .empty()
                .append(
                    '<div class="row"> ' +
                        '<div class="col-12 text-center"> ' +
                        '<h1>' +
                        data.resources.emptyCartMsg +
                        '</h1> ' +
                        '</div> ' +
                        '</div>'
                );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * 
 * @param {Object} totals Es la dats que viene en respuesta del llamado ajax
 * @returns {string} retorna la cantidad con formato
 */
function formatTotals(totals) {
    let totalsFormated = totals.startsWith('Mex$') ? totals.replace('Mex$', '$') + ' MXN' : totals.replace('Q$', '$') + ' GTQ';
    return totalsFormated;
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(`Productos (${data.items.length})`);
    $('.text-products').empty().append(`Subtotal (${data.items.length} productos)`);
    $('.shipping-cost').empty().append(formatTotals(data.totals.totalShippingCost));
    $('.tax-total').empty().append(formatTotals(data.totals.totalTax));
    $('.grand-total').empty().append(formatTotals(data.totals.grandTotal));
    $('.subtotal-cost').empty().append(data.totals.rawOrderTotal.formatTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.items.length);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0 || data.totals.rawOrderTotal.total > 0) {
        let orderLevelDiscountTotal = data.totals.rawOrderTotal.saving + data.totals.orderLevelDiscountTotal.value;
        let formattedTotal = orderLevelDiscountTotal.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total')
            .empty()
            .append('- $' + formattedTotal + ' '+ data.totals.rawOrderTotal.currency);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID)
                .empty()
                .append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price')
            .empty()
            .append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price')
            .empty()
            .append(item.renderedPrice);
        $('.item-total-' + item.UUID)
            .empty()
            .append(item.priceTotal.renderedPrice);
    });
}

/**
 * re-renders the recommended products and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateRecommendedProducts(data) {
    var result = data.artRec;
    var interatePriActual = $('.quantity-cantidad-pdp');
    var interatePriActualVisible = $('.quantity-cantidad-pdp:visible');

    if (result.length == interatePriActualVisible.length) {
        // Productos recomendados actuales
        if (result.length > 0 && interatePriActual.length > 0 && !$('.is-imc-card-global')[0].className.includes('d-none')) {
            for (var i = 0; i < interatePriActual.length; i++) {
                var countReturnPriTrue = 0;

                // Productos recomendados nuevos
                for (var s = 0; s < result.length; s++) {
                    if (interatePriActual[i].getAttribute('data-pid') == result[s].product.id) {
                        interatePriActual[i].setAttribute('data-pre-select-qty', (result[s].quantity).toString());
                        interatePriActual[i].value = (result[s].quantity).toString();
                        interatePriActual[i].setAttribute('value', (result[s].quantity).toString());
                        interatePriActual[i].setAttribute('aria-label', 'quantity: '+result[s].quantity);

                        $('.item-total-print-'+interatePriActual[i].getAttribute('data-uuid'))[1].innerText = '$'+(result[s].product.price.sales.value*result[s].quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')+' '+result[s].product.price.sales.currency;

                        countReturnPriTrue += countReturnPriTrue + 1;
                    };
                };

                if (countReturnPriTrue == 0) {
                    $('.uuid-'+interatePriActual[i].getAttribute('data-uuid'))[0].style.display = 'none';
                };
            };
        } else if (result.length == 0 && interatePriActual.length > 0 && !$('.is-imc-card-global')[0].className.includes('d-none')) {
            $('.is-imc-card-global').addClass('d-none');
        } else if (result.length > 0 && $('.is-imc-card-global')[0].className.includes('d-none')) {
            location.reload();
        }
    } else {
        location.reload();
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml =
        '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        message +
        '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html +=
                '<div class="single-approaching-discount text-center">' +
                item.discountMsg +
                '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages +=
                        '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages +=
                    '<p class="line-item-attributes line-item-instock-date">' +
                    lineItem.availability.inStockDate +
                    '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog quick-view-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(
                data.closeButtonText
            );
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

var getBasket = $('#getBasket').val();
/**
 * Check if the basket is empty
 * @returns {Object} - The basket data
 */
function checkBasket() {
    let callNumber = 0;
    let maxCalls = 10;
    return new Promise(function (resolve) {
        /**
         * Try to get the basket
         */
        function tryGetBasket() {
            $.ajax({
                url: getBasket,
                method: 'GET',
                success: function (data) {
                    callNumber++;
                    if (data && data.numItems > 0) {
                        window.location.reload();
                        resolve(data);
                    } else {
                        if (callNumber > maxCalls) {
                            window.location.reload();
                            return;
                        }
                        // call again after 1 second if basket is not available yet
                        setTimeout(tryGetBasket, 1000);
                    }
                },
                error: function () {
                    callNumber++;
                    if (callNumber > maxCalls) {
                        window.location.reload();
                        return;
                    }
                    // call again after 1 second if basket is not available yet
                    setTimeout(tryGetBasket, 1000);
                }
            });
        }

        tryGetBasket();
    });
}

/**
 * Check if the resolution is for a mobile device.
 * @returns {boolean} True if the resolution is mobile, false otherwise.
 */
function isMobile() {
    return window.matchMedia("(max-width: 543px)").matches;
}

$(document).ready(function() {
    var isCart = $('.cart-page').length > 0;
    var footerContent = $('#footercontent');
    if (footerContent && footerContent.length && isCart) {
        footerContent.addClass('footer-margin-bottom');
    }

    var params = new URLSearchParams(window.location.search);

    if (params.get('errorBlock') === 'true') {
        var errorMessageInventory = params.get('errorMessageInventory');
        if (errorMessageInventory) {
            var errorMessageElement = document.getElementById('error-message-inventory');
            if (errorMessageElement) {
                errorMessageElement.innerHTML = decodeURIComponent(errorMessageInventory);
            }
        }
        $('#error-inventory').modal('show');
    }
    if(params.get('lostSession') === 'true') { 
        var locationCookie = geolocationHelper.getCookie('dataUserObtenerMunicipios');
        var jsonLocation = JSON.parse(locationCookie);
        jsonLocation.CONFIRM_LOCATION = false;
        document.cookie = 'dataUserObtenerMunicipios=' + encodeURIComponent(JSON.stringify(jsonLocation)) + '; expires=Wed, 1 Jan 2070 13:47:11 UTC; path=/';
        var url = new URL(window.location);
        url.searchParams.delete('lostSession');
        window.history.replaceState({}, document.title, url.toString());

    }
    if(params.get('StoreLocked') === 'true') {
        // show error modal if store is locked
        var errorModal = params.get('errorModal');
        $('body').append(errorModal);
        $('#errorModalGeneric').modal('show');
        // remove params
        let currentUrl = new URL(window.location);
        currentUrl.searchParams.delete('StoreLocked');
        currentUrl.searchParams.delete('errorModal');
        window.history.replaceState({}, document.title, currentUrl.toString());
    }
    if (params.get('errorBasket') === 'true') {
        var emptyCart = $(".container-empty-cart");
        if (emptyCart.length > 0) {
            $.spinner().start();
            checkBasket();
        }
        let currentUrl = new URL(window.location);
        currentUrl.searchParams.delete('errorBasket');
        window.history.replaceState({}, document.title, currentUrl.toString());
    }
});

/**
 * Funcion deleteParamsUrl sirve para eliminar los parametros 'errorBlock' y 'errorMessageInventory' al momento de dar click en boton de modal y cerrarlo
 *
 */
function deleteParamsUrl() {
    const url = new URL(window.location);
    url.searchParams.delete('errorBlock');
    url.searchParams.delete('errorMessageInventory');
    window.history.replaceState({}, document.title, url.toString());
}

// Evento para el botón de cerrar el modal
document.addEventListener('DOMContentLoaded', function() {
    const closeModalButton = document.getElementById('close-modal-block-iventory');
    if (closeModalButton) {
        closeModalButton.addEventListener('click', deleteParamsUrl);
    }
});

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
            + response.message
            + '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

$(document).ready(function () {
    var formatUnitPrice = $('.unit-price-rec-cart');

    if (formatUnitPrice.length > 0) {
        for (var s = 0; s < formatUnitPrice.length; s++) {
            $('.unit-price-rec-cart')[s].innerText = $('.unit-price-rec-simb')[s].value + parseFloat($('.unit-price-rec-cart')[s].innerText).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + ' ' + $('.unit-price-rec-curre')[s].value;
        }
    }
    
    $('.btn-quote-create').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.fromButtonQuote = true;
        $('#cotizacionModal').modal('show');
    });
});

module.exports = function () {
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, productName, uuid);
    });
    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(
            data.actionUrl,
            data.productID,
            data.productName,
            data.uuid
        );
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn, .remove-item-from-cart', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');
        const removeMsg = $(this).data('msg-remove');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.searchImpressionData) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ ecommerce: null });
                    window.dataLayer.push(JSON.parse(data.searchImpressionData));
                }

                if (data.basket.items.length === 0) {
                    $('.number-of-items')
                        .empty()
                        .append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity')
                        .empty()
                        .append(data.basket.numItems);

                    // Show or hide quantity number in minicart icon
                    if (data.basket.numItems > 0) {
                        $('.minicart-quantity').removeClass('d-none');
                    } else {
                        $('.minicart-quantity').addClass('d-none');
                        $('.background-overlay').addClass('d-none');
                    }

                    $('.minicart-link').attr({
                        'aria-label':
                            data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                    if($('#isCart').val() == true || $('#isCart').val() == 'true') {
                        window.location.reload();
                    }

                } else {
                    if (
                        data.toBeDeletedUUIDs &&
                        data.toBeDeletedUUIDs.length > 0
                    ) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(
                        data.basket.approachingDiscounts
                    );
                    $('body').trigger(
                        'setShippingMethodSelection',
                        data.basket
                    );
                    validateBasket(data.basket);
                    updateRecommendedProducts(data);
                }

                let dataCopy = data;
                dataCopy.message = removeMsg;
                dataCopy.error = true; // to show alert-danger
                handlePostCartAdd(dataCopy);

                $('body').trigger('cart:update', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.add-to-cart', function () {
        var pid;
        var addToCartUrl;
        var pidsQty;
        var uuidClick = $(this).get()[0].getAttribute('data-uuid');

        $('body').trigger('product:beforeAddToCart', this);

        pid = $(this).data('pid');
        addToCartUrl = $(this).data('url');
        const DEFAULTQTY = $(this).parents('.attributes').find('.CantidadProd').val()
        pidsQty = parseInt(DEFAULTQTY, 10);

        var form = {
            pid: pid,
            quantity: pidsQty ? pidsQty : 1
        };

        if ($(this).data('option')) {
            form.options = JSON.stringify($(this).data('option'));
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    if (data.searchImpressionData) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ecommerce: null});
                        window.dataLayer.push(JSON.parse(data.searchImpressionData));
                    }
                    handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    // base.miniCartReportingUrl(data.reportingURL, data.error);
                    location.reload();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    $('body').on('click', '.add-to-cart-prm', function () {
        var pid;
        var addToCartUrl;
        var pidsQty;
        var uuidClick = $(this).get()[0].getAttribute('data-uuid');

        $('body').trigger('product:beforeAddToCart', this);

        pid = $(this).data('pid');
        addToCartUrl = $(this).data('url');
        const DEFAULTQTY = $(this).parents('div.row').find('.quantity-cantidad-pdp-'+uuidClick).val();
        pidsQty = parseInt(DEFAULTQTY, 10);

        var form = {
            pid: pid,
            quantity: pidsQty
        };

        if ($(this).data('option')) {
            form.options = JSON.stringify($(this).data('option'));
        }
        $.spinner().start();
        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    if (data.searchImpressionData) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(JSON.parse(data.searchImpressionData));
                    }
                    handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    // base.miniCartReportingUrl(data.reportingURL, data.error);
                    location.reload();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    $('#sendQuote').on('click', function () {
        let url = $('input[name="sendQuote"]').val();
        let imageSuccess = $('input[name="imageSuccess"]').val();
        let nameQuote = $('#nameQuote').val();
        if (nameQuote === '') {
            $('#nameQuote').addClass('is-invalid');
            $('#nameQuoteError').text(
                'Por favor, ingresa un nombre para la cotización.'
            );
            return;
        }
        $('#nameQuote').removeClass('is-invalid');
        $('#nameQuoteError').text('');
        let data = {
            nameQuote: nameQuote
        };
        $('#cotizacionModal').spinner().start();
        $.ajax({
            url: url,
            data: data,
            type: 'POST',
            success: function (response) {
                if (response && response.errorModalBlockSale) {
                    $('#cotizacionModal').modal('hide');
                    var errorModalGeneric = $('#errorModalGeneric');
                    if (!errorModalGeneric.length) {
                        $('body').append(response.errorModalBlockSale);
                    }
                    $('#errorModalGeneric').modal('show');
                    $.spinner().stop();
                    return;
                }
                if (response && response.message && response.listExist) {
                    $('#nameQuote').addClass('is-invalid');
                    $('#nameQuoteError').text(response.message);
                    $.spinner().stop();
                    return;
                }
                var bodyContainer = $('.modalbodyCotizacion');
                bodyContainer.empty();
                if (response.success && !response.error && response.folio) {
                    $('#cotizacionModal').modal('hide');
                    window.location.replace(
                        `${response.urlRedirect}?folio_cotizacion=${response.folio}`
                    );
                } else if (!response.success && response.error) {
                    $('.modal-cotizacion-cart').addClass('d-none');
                    let resServiceFail = `
                    <div class="text-center text-danger">
                        <p>${response.error}</p>
                    </div>
                    <button type="button" data-dismiss="modal" id="goCart" class="btn btn-primary col-12 mb-3">Regresar a carrito</button>
                    `;
                    bodyContainer.append(resServiceFail);
                }
                $.spinner().stop();
                $('#goCart').on('click', () => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 200);
                });
            },
            error: function () {
                $.spinner().stop();
                let msj = $('#mensajeErrorGral-1').val();
                $('.modal-content').empty();
                $('.modal-content').append(`
                <div d-flex justify-content-center><img src=${errorSintrGif} class="d-block mx-auto"></div>
                <p class="mb-3">${msj}</p>
                <button type="button" data-dismiss="modal" id="goNavigate" class="btn btn-primary col-12 mb-3">Seguir comprando</button>`);
                $('#quotationModal').on('click', '#goNavigate', () => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 200);
                });
                $.spinner().stop();
            }
        });
    });

    $('#nameQuote').on('focus', function () {
        if ($('#nameQuote').hasClass('is-invalid')) {
            $('#nameQuote').removeClass('is-invalid');
            $('#nameQuoteError').text('');
        }
    });

    $('body').on('change', '.quantity-form > .onlyEntireNumbers', function(e) {
        e.preventDefault();
        let currentElement = e.currentTarget;
        if ($('#isCart').val() == "true") {
            var productID = currentElement.dataset.pid;
            var quantity = parseInt(currentElement.value, 10);
            var url = currentElement.dataset.action;
            var uuid = currentElement.dataset.uuid;
            var urlParams = {
                pid: productID,
                quantity: quantity,
                uuid: uuid
            };
            url = appendToUrl(url, urlParams);
    
            setTimeout(() => {
                $('body').spinner().start();
                $('body').trigger('cart:beforeUpdate');
                $.ajax({
                    url: url,
                    type: 'get',
                    context: currentElement,
                    dataType: 'json',
                    success: function(data) {
                        $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        updateAvailability(data, uuid);
                        validateBasket(data);
                        updateRecommendedProducts(data)
    
                        $('body').trigger('cart:update', data);
                        $('body').spinner().stop();
                    },
                    error: function(err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification(err.responseJSON.errorMessage);
                            $(this).val(parseInt(currentElement.dataset.preSelectQty, 10));
                            $('body').spinner().stop();
                        }
                    }
                });
            }, 1000);
        }
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $('body').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos')
                    .empty()
                    .append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                updateRecommendedProducts(data)
                $(this).data('pre-select-qty', quantity);

                $('body').trigger('cart:update', data);

                $.spinner().stop();
                if (
                    $(this)
                        .parents('.product-info')
                        .hasClass('bonus-product-line-item') &&
                    $('.cart-page').length
                ) {
                    location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('keypress, keyup', '.quantity-form > .quantity-pdp', function (e) {
        var valueActual = $(this).val();
        var valueCount = $(this).parents('div.row').find('.quantity-cantidad-pdp').length;
        var campCount = $(this).parents('div.row').find('.unit-price-rec-cart').length;
        var realId = $(this)[0].id;

        for (var i = 0; i < valueCount; i++) {
            if (realId == $(this).parents('div.row').find('.quantity-cantidad-pdp')[i].id) {
                $(this).parents('div.row').find('.quantity-cantidad-pdp')[i].value = valueActual;
            }
        };
        for (var t = 0; t < campCount; t++) {
            if ($(this)[0].getAttribute('data-uuid') == $(this).parents('div.row').find('.unit-price-rec-cart')[t].getAttribute('data-uuid')) {
                $(this).parents('div.row').find('.unit-price-rec-cart')[t].innerText = $(this).parents('div.row').find('.unit-price-rec-cart')[t].getAttribute('price-simb') + (parseFloat($(this).parents('div.row').find('.unit-price-rec-cart')[t].getAttribute('price-unit'))*valueActual).toFixed(2) + $(this).parents('div.row').find('.unit-price-rec-cart')[0].getAttribute('price-current');
                ;
            }
        };
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr(
                'aria-describedby',
                'missingCouponCode'
            );
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr(
                        'aria-describedby',
                        'invalidCouponCode'
                    );
                    $('.coupon-error-message')
                        .empty()
                        .append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos')
                        .empty()
                        .append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on(
        'click',
        '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit',
        function (e) {
            e.preventDefault();

            var editProductUrl = $(this).attr('href');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        }
    );

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer).closest(
            '.quick-view-dialog'
        );

        $('.update-cart-product-global', dialog).attr(
            'disabled',
            !$('.global-availability', dialog).data('ready-to-order') ||
                !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer).closest(
            '.quick-view-dialog'
        );

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog)
                .toArray()
                .every(function (item) {
                    return $(item).data('available');
                });

            var allReady = $('.product-availability', dialog)
                .toArray()
                .every(function (item) {
                    return $(item).data('ready-to-order');
                });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog)
                .empty()
                .html(
                    allReady
                        ? response.message
                        : response.resources.info_selectforstock
                );
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show')
                .find(response.container)
                .data('pid', response.data.product.id);
            $('.modal.show')
                .find(response.container)
                .find('.product-id')
                .text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data(
                'pid',
                response.data.product.id
            );
        }
    });

    $('.checkout-btn-text').on('click', function(e) {
        e.preventDefault();
        let showModalInventory = false;
        let priceWithNA = $('.line-item-total-price-amount');
        if (priceWithNA.length) {
            priceWithNA.each(function (index, productItem) {
                if ($(productItem).text().trim() === "N/A") {
                    showModalInventory = true ;
                }
            });
        }
        
        if (showModalInventory) {
            $('#checkAvailability').modal('show');
        } else {
            $.spinner().start();
            setTimeout(function() {
                window.location.href = e.currentTarget.href;
                $.spinner().stop();
            }, 1500);
        } 
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data(
            'selected-quantity',
            selectedQuantity
        );
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this)
            .children('option:selected')
            .data('value-id');
        $('.modal.show .update-cart-url').data(
            'selected-option',
            selectedOptionValueId
        );
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .val();
        var selectedQuantity = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('selected-quantity');
        var selectedOptionValueId = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('selected-option');
        var uuid = $(this)
            .closest('.cart-and-ipay')
            .find('.update-cart-url')
            .data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos')
                        .empty()
                        .append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(
                        data.cartModel.approachingDiscounts
                    );
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
